import useBreakpoint from "antd/es/grid/hooks/useBreakpoint";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { CustomTooltip, TableAbstract } from "shared/components/Components";
import { useMercuryContext } from "../../context";

class EmpowerDepartment extends TableAbstract<any> {
  defaultSortField = "departmentId";

  FilterComponents: any[] = [];

  columns = [
    {
      id: "departmentName",
      title: "Department Name",
      dataIndex: "departmentName",
      sorter: true,
      width: 200,
      render: (text: string | null | undefined) =>
        text ? <CustomTooltip text={text} length={25} /> : "Not Set",
    },
    {
      id: "departmentId",
      title: "Department ID",
      dataIndex: "departmentId",
      sorter: true,
      width: 150,
      render: (value: number | null | undefined) => value ?? "Not Set",
    },
    {
      id: "parentDepartmentId",
      title: "Parent Department ID",
      dataIndex: "parentDepartmentId",
      sorter: true,
      width: 180,
      render: (value: number | null | undefined) => value ?? "Not Set",
    },
    {
      id: "chartOfAccountsCode",
      title: "Chart of Accounts Code",
      dataIndex: "chartOfAccountsCode",
      sorter: true,
      width: 200,
      render: (value: string | null | undefined) => value || "Not Set",
    },
    {
      id: "languageServices",
      title: "Language Services",
      dataIndex: "languageServices",
      sorter: true,
      width: 200,
      align: "center" as any,
      render: (value: boolean | null | undefined) =>
        value === null || value === undefined ? (
          "Not Set"
        ) : value ? (
          <CheckOutlined style={{ color: "var(--tertiary-color)" }} />
        ) : (
          <CloseOutlined style={{ color: "var(--red)" }} />
        ),
    },
  ];

  pageTitle = "Manage Empower Departments - Mercury";
  title = "Empower Departments";
  pageClass = "empowerDepartmentTable";

  async fetch(): Promise<any> {
    const { sortOrder, sortField, currentPage, itemsPerPage } = this.state;

    const requestPayload = {
      filter: this.filtersToQuery(),
      pagination: {
        pageNumber: currentPage || 1,
        resultsPerPage: itemsPerPage,
      },
      sort: {
        [sortField || "departmentId"]: sortOrder === "ascend" ? 1 : -1,
      },
    };

    const response = await this.userContext.coreClient.post(
      "/core-v1/empower-departments/search",
      requestPayload
    );

    const documents: any[] = response?.data?.documents || [];
    const meta = response?.data?.meta ?? {
      total: 0,
      page: currentPage,
      pages: 1,
      skip: 0,
      limit: itemsPerPage,
      match: {},
      sort: { departmentId: -1 },
    };

    return {
      data: {
        documents,
        meta,
      },
    };
  }
}

export default function ManageEmpowerDepartment() {
  const context = useMercuryContext();
  const breaks = useBreakpoint();

  return (
    // @ts-ignore
    <EmpowerDepartment
      id="ManageEmpowerDepartment"
      context={context}
      breaks={breaks as any}
      useLegacyEndpoints={false}
      hasSidebar={true}
      noSelect
      hideDefaultFilters={true}
    />
  );
}
